import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { useMediaQuery } from 'app/hooks/useMediaQuery';

import { TProps } from './types/TProps';

export const Diff = ({ left, right, method = DiffMethod.WORDS_WITH_SPACE }: TProps) => {
  const splitView = useMediaQuery('(min-width: 768px)');
  return (
    <ReactDiffViewer
      oldValue={left}
      newValue={right}
      splitView={splitView}
      showDiffOnly={true}
      useDarkTheme={false}
      compareMethod={method}
    />
  );
};
